import { CostCenterModel } from "../../services/finOpsManagerService";
import { TreeItem, RecordItem, CostCenterNode } from "./costCenter.Models";

export function formatTree(row: any, index: number) {
    const array: TreeItem[] = [];
    const _records: RecordItem[] = [];

    function formatSingleItem(item: any, parentId: number | undefined) {
        array.push({
            id: item.id,
            "Nome do centro de custo": item.name
        });

        _records.push({
            id: array.length,
            name: item.name,
            parentName: parentId ? array.find(x => x.id === parentId)?.["Nome do centro de custo"] || "" : "",
            parentId: parentId || 0,
            costCenterId: item.id,
            budget: item.budget,
            qtdSubscription: item.qtdSubscription,
            isMain: item.isMain,
            active: item.active,
            children: item.children
        });

        if (item.children && item.children.length > 0) {
            item.children.forEach((child: any) => {
                formatSingleItem(child, item.id);
            });
        }
    }

    formatSingleItem(row, undefined);

    return { array, _records };
}

export const findCostCenterById = (tree: CostCenterNode[], costCenter: any): CostCenterNode | undefined => {
    const queue = tree;
    while (queue.length > 0) {
        const currentNode = queue.shift();
        if (currentNode) {
            if (currentNode.name.toLowerCase() === costCenter.Name.toLowerCase() && currentNode.budget === Number(costCenter.Budget)) {
                return currentNode;
            }
            if (currentNode.children && currentNode.children.length > 0) {
                queue.push(...currentNode.children);
            }
        } else {
            return undefined;

        }
    }
}

export const formatValue = (obj: CostCenterModel) => {
    var valor = (obj !== undefined) ? obj.budget : 0;
    valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    var nome = (obj !== undefined) ? obj.name : "";
    var formatedValue = "$ " + valor + " - " + nome;

    return formatedValue;
}

export  const convertValue = (value: any) => {
    return value ? parseFloat(value).toFixed(2) : null;
}
export const filterDomainEmail = (list) => {
    const domainsExcluded = ["@processor.com.br", "@gotobiz.com.br", "@testesportal.onmicrosoft.com"];
    // Filtrar o array de objetos
    const arrayFiltrado = list.filter((objeto) => {
        // Verificar se o campo "email" não contém nenhum dos domínios excluídos
        return !domainsExcluded.some((dominio) => objeto.email.includes(dominio))
    });

    return arrayFiltrado;
}
